import React from "react";
import { Avatar as AntdAvatar } from "antd";
import ImagePlaceholder from "assets/img/placeholder/image_placeholder.svg"
import classes from "./Avatar.module.scss";
import cn from "classnames";
import PropTypes from "prop-types";

const AAvatar = ({ src, className, size, ...rest }) => {
  let avatarSize;
  if (size === null || size === undefined) {
    avatarSize = 96;
  } else {
    switch (size) {
      case 'small':
        avatarSize = 30; // or any other value you want
        break;
      case 'medium':
        avatarSize = 'default'; // 'default' size in Ant Design is medium
        break;
      case 'large':
        avatarSize = 60; // or any other value you want
        break;
      default:
        avatarSize = size; // if size is a number
    }
  }

  return <AntdAvatar src={src ? src : ImagePlaceholder} size={avatarSize} className={[classes.icwAvatar, className]} {...rest}></AntdAvatar>
}

AAvatar.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['small', 'medium', 'large']),
    PropTypes.number
  ])
};
export default AAvatar;